import { Table } from 'antd';
import { useSelector } from 'react-redux';

export const SettingsShowAbscenceTimeModal = () => {
  const { configs } = useSelector((state) => state.configs);

  const abscenceTime = configs?.abscenceTime || {};

  const dataSource = [
    {
      key: 'freezeScreen',
      label: 'Pantalla congelada',
      value: abscenceTime.freezeScreen,
    },
    {
      key: 'idleTime',
      label: 'Tiempo de inactividad',
      value: abscenceTime.idleTime,
    },
  ];

  const columns = [
    {
      title: 'Configuración',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Valor (segundos)',
      dataIndex: 'value',
      key: 'value',
      render: (value) => value ?? '-',
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      bordered
      size="middle"
    />
  );
};
